import { render, staticRenderFns } from "./ShiftUpdateModal.vue?vue&type=template&id=5ec544fa"
import script from "./ShiftUpdateModal.vue?vue&type=script&lang=js"
export * from "./ShiftUpdateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports